import { API } from 'aws-amplify';

function init(arg0: string, arg1: string, _init: any, any: any)
{
	throw new Error('Function not implemented.');
}

export const getConifgSettings = (queryStringParameters) =>
{
	return API.get('userManagement', '/configurations/contract', { queryStringParameters });
};
export const updateConfigSettings = (body) =>
{
	return API.post('userManagement', '/configurations', { body });
};
export const postBrandingWatermakData = (body) =>
{
	return API.post('userManagement', '/configurations', { body });
};
export function getTemplatesList(query:any)
{
	return API.get('connectionManagement', `/agreementTemplate${query}`, init);
}
export function getTemplate(queryStringParameters:any)
{
	return API.get('connectionManagement', '/agreementTemplate', { queryStringParameters });
}

export function createContractTemplate(body:any)
{
	return API.post('connectionManagement', '/agreementTemplate', { body });
}
export function updateContractTemplate(body:any)
{
	return API.put('connectionManagement', '/agreementTemplate', { body });
}
export function deleteContractTemplate(queryStringParameters:any)
{
	return API.del('connectionManagement', '/agreementTemplate', { queryStringParameters });
}
export const getTempRelations = (queryStringParameters) =>
{
	return API.get('departments', '/relations', { queryStringParameters });
};
export const getUserComments = (queryStringParameters) =>
{
	return API.get('connectionManagement', '/getComment', { queryStringParameters });
};
export const postUserComment = (body) =>
{
	return API.post('connectionManagement', '/postComment', { body });
};
export const getContractList = (queryStringParameters) =>
{
	return API.get('connectionManagement', '/contract', { queryStringParameters });
};
export const postUserAction = (body) =>
{
	return API.post('connectionManagement', '/contract', { body });
};
export const updateWithdrawContract = (body) =>
{
	return API.put('connectionManagement', '/contract', { body });
};

export const authTokenConfig = (body) =>
{
	return API.get('connectionManagement', '/authenticateApi ', { body });
};